<template>
  <gat-alert-dialog
    :open="showDialog"
    :title="errorStore.errorDialogProps.title"
    :text="errorStore.errorDialogProps.message"
    type="error"
  >
    <template #footer>
      <div
        v-if="errorStore.errorDialogProps.options.forceRefresh"
        class="flex grow items-center gap-4"
      >
        <div class="text-soft text-sm">
          You will need to refresh the page to continue.
        </div>
        <gat-button class="ml-auto" @click="refreshPage()"
          >Refresh Page</gat-button
        >
      </div>
      <gat-button
        v-else
        class="ml-auto"
        variant="ghost"
        @click="errorStore.closeDialog()"
        >Close</gat-button
      >
    </template>
  </gat-alert-dialog>
</template>

<script setup lang="ts">
  import { useErrorStore } from '@gat-ship/lib/http-client'
  import { computed } from 'vue'

  const errorStore = useErrorStore()

  const showDialog = computed(() => errorStore.errorDialogProps.showDialog)

  function refreshPage() {
    window.location.reload()
  }
</script>
